export const WHATSAPP_NUMBER = "393392764821";

export const INSTAGRAM_URL = "https://www.instagram.com/_grandlinecards_";
export const TIKTOK_URL = "https://www.tiktok.com/@_grandlinecards_";

export const waLink = (message) =>
  `https://wa.me/${WHATSAPP_NUMBER}?text=${encodeURIComponent(message)}`;

const px = (id, w = 800, h = 1120) =>
  `https://images.pexels.com/photos/${id}/pexels-photo-${id}.jpeg?auto=compress&cs=tinysrgb&fit=crop&w=${w}&h=${h}`;

export const HERO_CARD_IMAGE = px(9661257);

export const MARQUEE_ITEMS = [
  "Pokémon TCG",
  "One Piece Card Game",
  "Booster Box",
  "Carte Gradate",
  "Manga Rare",
  "Sealed Collection",
  "Elite Trainer Box",
];

export const CHAPTERS = [
  {
    id: "pokemon",
    number: "01",
    title: "Pokémon TCG",
    subtitle: "Box ETB Collezioni",
    products: [
      {
        id: "pk-rivali",
        name: "Rivali Predestinati",
        detail: "Booster Box · 36 buste · Sealed",
        price: "€ 240,00",
        image: "/assets/box-rivali-predestinati.webp",
        contain: true,
      },
      {
        id: "pk-scintille",
        name: "Scintille Folgoranti",
        detail: "Booster Box · 36 buste · Sealed",
        price: "€ 230,00",
        image: "/assets/box-scintille-folgoranti.webp",
        contain: true,
      },
      {
        id: "pk-megaevoluzione",
        name: "Megaevoluzione",
        detail: "Booster Box · 36 buste · Sealed",
        price: "€ 230,00",
        image: "/assets/box-megaevoluzione.webp",
        contain: true,
      },
      {
        id: "pk-abyss-eye",
        name: "Mega Abyss Eye (JAP)",
        detail: "Booster Box · Edizione Giapponese · Sealed",
        price: "€ 120,00",
        image: "/assets/box-abyss-eye.webp",
        contain: true,
      },
      {
        id: "pk-abyss-bustina",
        name: "Mega Abyss Eye (JAP) — Bustina",
        detail: "1 bustina · Edizione Giapponese",
        price: "€ 5,00",
        image: "/assets/bustina-abyss-eye.jpg",
        contain: true,
      },
      {
        id: "pk-mega-bustina",
        name: "Megaevoluzione (ITA) — Bustina",
        detail: "1 bustina · 10 carte · Edizione Italiana",
        price: "€ 6,50",
        image: "/assets/bustina-megaevoluzione-ita.jpg",
        contain: true,
      },
      {
        id: "pk-prismatiche",
        name: "Evoluzioni Prismatiche",
        detail: "Collezione Super Premium · Sealed",
        price: "€ 169,99",
        image: "/assets/collezione-evoluzioni-prismatiche.jpg",
        contain: true,
      },
      {
        id: "pk-buio-pesto",
        name: "Megaevoluzione Buio Pesto",
        detail: "Set Allenatore Fuoriclasse · Sealed",
        price: "€ 65,00",
        image: "/assets/etb-buio-pesto.webp",
        contain: true,
      },
      {
        id: "pk-ascesa",
        name: "Ascesa Eroica — Bundle 6 Buste",
        detail: "Megaevoluzione · Confezione 6 buste · Sealed",
        price: "€ 46,00",
        image: "/assets/bundle-ascesa-eroica.webp",
        contain: true,
      },
      {
        id: "pk-serie2",
        name: "First Partner Serie 2 (ITA)",
        detail: "Collezione Illustrata · 3 buste",
        price: "€ 35,00",
        image: "/assets/first-partner-serie2.jpg",
        contain: true,
      },
      {
        id: "pk-serie3",
        name: "First Partner Serie 3 (ITA)",
        detail: "Collezione Illustrata · 2 buste + promo",
        price: "€ 35,00",
        image: "/assets/first-partner-serie3.jpg",
        contain: true,
      },
    ],
  },
  {
    id: "onepiece",
    number: "02",
    title: "One Piece Card Game",
    subtitle: "Box",
    products: [
      {
        id: "op-luffy-promo",
        name: "Monkey D. Luffy — Magazine Vol.21 Promo",
        detail: "ST29-001 · Promo Card",
        availability: "In arrivo",
        image: "/assets/luffy-magazine-st29.jpg",
        contain: true,
      },
      {
        id: "op-luffy-elbaf",
        name: "Luffy Elbaf P-159 — Coppia Holo + Non Holo",
        detail: "P-159 · Promo 29th Anniversary",
        availability: "In arrivo",
        image: "/assets/luffy-elbaf-p159.jpg",
        contain: true,
      },
    ],
  },
];
